import * as SliderTheme from './components/Slider.css';
import { EngineTheme } from '../theme';

export interface WithThemeProps {
	theme: EngineTheme;
}

export default { SliderTheme };
